import HttpClient from "../../../service/HttpService";
import state from "./state";
import MenuService from "../../../service/MenuService"
import ConfiguracaoService from "../../../service/ConfiguracaoService";

export default {
  getDialetos() {
    return new Promise((resolve) => {
      if (state.dialetos) {
        resolve(state.dialetos);
      } else {
        HttpClient.backApi.get("/dialetos").then(response => {
          state.dialetos = response.data;
          resolve(state.dialetos);
        });
      }
    });
  },
  clear() {
    state.dialetos = null;
    state.flMostraPerpetua = null;
    state.menus = null;
  },
  getConfig() {
    return new Promise((resolve) => {
      if (state.flMostraPerpetua) {
        resolve(state.flMostraPerpetua);
      } else {
        ConfiguracaoService.consultar().then(response => {
          state.flMostraPerpetua = response.data.flMostraPerpetua;
          state.flMostraCodigoSepultamento = response.data.flMostraCodigoSepultamento;
          state.flEmImplantacao = response.data.flEmImplantacao;
          resolve(state.flMostraPerpetua);
        });
      }
    });
  },
  setCdCemiterio({commit}, cdCemiterio) {
    localStorage.setItem("cdCemiterio", cdCemiterio);
  },
  listarMenu() {
    return new Promise((resolve) => {
      if (state.menus) {
        resolve(state.menus);
      } else {
        MenuService.listarCompleto().then(response => {
          state.menus = response.data;
          resolve(state.menus);
        });
      }
    });
  }
};
